import { differenceInMinutes } from "date-fns";
import { toast } from "react-hot-toast";

import ToastDisplay from "../components/ToastDisplay";
import Skeleton from "react-loading-skeleton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

const DeviceDetails = ({ loading, device }) => {
	const isOnline = (dateTime) => {
		return differenceInMinutes(new Date(), new Date(dateTime)) < 3;
	};

	const copyToClipbnoard = (text) => {
		navigator.clipboard.writeText(text);
		toast(<ToastDisplay status="success" content="Copied to clipboard." />);
	};

	return (
		<div>
			<div className="bg-white rounded-8 p-20 mb-30">
				<div className="mb-20">
					<h2 className="text-xl text-medium-gotham mb-0">
						Device Information
					</h2>
				</div>
				<Row className="mb-30">
					<Col>
						<span className="info-label text-sm text-medium-gotham block">
							{loading ? (
								<Skeleton
									width={120}
									height={15}
									baseColor="#dadee7"
									highlightColor="#e9ecf2"
								/>
							) : (
								"Name"
							)}
						</span>
						<span className="info-val">
							{loading ? (
								<Skeleton
									width={"30%"}
									height={25}
									baseColor="#dadee7"
									highlightColor="#e9ecf2"
								/>
							) : (
								device?.name || "--"
							)}
						</span>
					</Col>
					<Col>
						<span className="info-label text-sm text-medium-gotham block">
							{loading ? (
								<Skeleton
									width={120}
									height={15}
									baseColor="#dadee7"
									highlightColor="#e9ecf2"
								/>
							) : (
								"Status"
							)}
						</span>
						<span className="info-val">
							{loading ? (
								<Skeleton
									width={"30%"}
									height={25}
									baseColor="#dadee7"
									highlightColor="#e9ecf2"
								/>
							) : device.last_heartbeat && isOnline(device.last_heartbeat) ? (
								<span className="device-status label-md text-medium-gotham text-white fit online">
									Online
								</span>
							) : (
								<span className="device-status label-md text-medium-gotham text-white fit offline">
									Offline
								</span>
							)}
						</span>
					</Col>
				</Row>
				<Row className="mb-30">
					<Col>
						<span className="info-label text-sm text-medium-gotham block">
							{loading ? (
								<Skeleton
									width={120}
									height={15}
									baseColor="#dadee7"
									highlightColor="#e9ecf2"
								/>
							) : (
								"Device Type"
							)}
						</span>
						<span className="info-val">
							{loading ? (
								<Skeleton
									width={"80%"}
									height={25}
									baseColor="#dadee7"
									highlightColor="#e9ecf2"
								/>
							) : (
								device?.device_type || "--"
							)}
						</span>
					</Col>
					{device?.type === "Vehicle" && (
						<Col>
							<span className="info-label text-sm text-medium-gotham block">
								{loading ? (
									<Skeleton
										width={120}
										height={15}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : (
									"License Plate"
								)}
							</span>
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"80%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : (
									device?.license_plate || "--"
								)}
							</span>
						</Col>
					)}
				</Row>
				<Row className="mb-30">
					<Col>
						<span className="info-label text-sm text-medium-gotham block">
							{loading ? (
								<Skeleton
									width={120}
									height={15}
									baseColor="#dadee7"
									highlightColor="#e9ecf2"
								/>
							) : (
								"Device Key"
							)}
						</span>
						<div className="flex-row-left">
							<span className="info-val">
								{loading ? (
									<Skeleton
										width={"80%"}
										height={25}
										baseColor="#dadee7"
										highlightColor="#e9ecf2"
									/>
								) : (
									device?.key || "--"
								)}
							</span>
							{!loading && (
								<Button
									variant="light"
									className="device-copy-btn flex-column ms-2 rounded-4"
									onClick={() => copyToClipbnoard(device?.key)}
								>
									<i className="ri-file-copy-line m-0" />
								</Button>
							)}
						</div>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default DeviceDetails;
